import { useEffect, useMemo, useState } from "react";
import { honeyVestingContract } from "config";
import { useContractRead } from "wagmi";
import { BigNumber } from "ethers";

const useVestingAmountRemaining = (
  method: string,
  address?: string
): [
  remaining: Record<number, BigNumber> | undefined,
  remainingSum: BigNumber | undefined,
  readVestingAmountRemaining: () => void
] => {
  const [remaining, setRemaining] = useState<Record<number, BigNumber>>();
  const remainingSum = useMemo(
    () =>
      remaining
        ? Object.values(remaining).reduce(
            (sum, val) => sum.add(val),
            BigNumber.from("0")
          )
        : undefined,
    [remaining]
  );

  const [{ data: remainingData }, readVestingAmountRemaining] = useContractRead(
    {
      addressOrName: honeyVestingContract.address,
      contractInterface: honeyVestingContract.interface,
    },
    method,
    {
      args: address,
    }
  );

  useEffect(() => {
    if (remainingData !== undefined) {
      const data = remainingData as [BigNumber[], BigNumber[]];

      setRemaining(
        data[1].reduce(
          (prev, tokenId, i) => ({
            ...prev,
            [tokenId.toNumber()]: data[0][i],
          }),
          {}
        ) as Record<number, BigNumber>
      );
    }
  }, [remainingData]);

  return [remaining, remainingSum, readVestingAmountRemaining];
};

export default useVestingAmountRemaining;
